import React from 'react';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../contexts/LanguageContext';
import useOtherLaborPriceData from './hooks/useOtherLaborPriceData';
import OtherLaborPriceForm from './components/OtherLaborPriceForm';
import OtherLaborPriceTable from './components/OtherLaborPriceTable';

const OtherLaborPricePage = () => {
    const { th } = useLanguage();
    const {
        items,
        totalRecords,
        isLoading,
        isDeleting,
        dialogVisible,
        selectedItem,
        page,
        pageSize,
        handleNew,
        handleEdit,
        handleSave,
        handleDelete,
        handlePage,
        handleCloseDialog
    } = useOtherLaborPriceData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">
                    {th('otherLaborPrice.pageTitle') || 'Diğer Onarım İşçilik Ücreti'}
                </h1>
                <div className="flex gap-2">
                    <Button
                        label={th('otherLaborPrice.newRecord') || 'Yeni Kayıt'}
                        icon="pi pi-plus"
                        onClick={handleNew}
                    />
                </div>
            </div>

            <OtherLaborPriceTable
                items={items}
                totalRecords={totalRecords}
                isLoading={isLoading}
                page={page}
                pageSize={pageSize}
                onPage={handlePage}
                onEdit={handleEdit}
                onDelete={handleDelete}
            />

            <OtherLaborPriceForm
                visible={dialogVisible}
                onHide={handleCloseDialog}
                onSubmit={handleSave}
                initialData={selectedItem}
                isLoading={isLoading || isDeleting}
            />
        </div>
    );
};

export default OtherLaborPricePage;

